import { useNavigate } from 'react-router-dom'

import avatarPlaceholder from 'assets/images/user_placeholder.png'

import style from './_quick-contact.module.scss'

interface Props {
  user?: {
    amount_of_messages: number
    conversation_id: string
    other_user_id: number
    display_name: string
    avatar: string
  }
  isPlaceholder?: boolean
  isLoading?: boolean
}

export const QuickContact = ({
  user,
  isPlaceholder = false,
  isLoading = false
}: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (isPlaceholder || isLoading || !user) return

    navigate(`/chat/${user.other_user_id}`, {
      state: {
        conversationId: user.conversation_id,
        otherUserData: {
          id: user.other_user_id,
          name: user.display_name,
          display_name: user.display_name,
          avatar: user.avatar ? { url: user.avatar } : null,
          isSubscribed: true // they are only returned if subscribed = true
        }
      }
    })
  }

  if (isLoading) {
    return (
      <div className={style.container} style={{ pointerEvents: 'none' }}>
        <div className={style.avatar}>
          <span className="processingFileLoader" />
        </div>
        <div className={style.user_name}>Loading...</div>
      </div>
    )
  }

  if (isPlaceholder) {
    return (
      <div
        className={style.container}
        style={{ pointerEvents: 'none', opacity: 0.7 }}
      >
        <div className={style.avatar}>
          <img src={avatarPlaceholder} alt="placeholder avatar" />
        </div>
        <div className={style.user_name}>No Users</div>
      </div>
    )
  }

  if (!user) return null

  return (
    <div className={style.container} onClick={handleClick}>
      <div className={style.avatar}>
        <img src={user.avatar || avatarPlaceholder} alt="user avatar" />
      </div>
      <div className={style.user_name}>{user.display_name}</div>
    </div>
  )
}